exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.Separator[data-v-5d2fe296] {\n  cursor: col-resize;\n  position: absolute;\n  z-index: 1;\n  top: 48px;\n  left: 50%;\n  bottom: 0;\n  width: 1px;\n  padding: 0 5px;\n  margin-left: -5px;\n}\n.Separator[data-v-5d2fe296]:after {\n    content: '';\n    display: block;\n    height: 100%;\n    background: #ccc;\n    transition: all 0.1s;\n}\n", ""]);

// exports
